import { faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tab, Tabs } from '@mui/material';
import { NavLink, Outlet, useLocation } from 'react-router';

import CheckPermissions from '@/components/CheckPermissions';
import LoadingIndicator from '@/components/LoadingIndicator';
import { PERMISSIONS } from '@/constants/auth.constants';
import Header from '@/layout/Header/Header';
import MainContent from '@/layout/MainContent';

import { AnnouncementDialog } from './AnnouncementDialog';
import { AnnouncementDialogType } from './AnnouncementDialog/AnnouncementDialog.constants';
import useAnnouncementDialog from './AnnouncementDialog/AnnouncementDialog.hooks';
import { ANNOUNCEMENTS_TABS } from './Announcements.constants';
import { useFetchAnnouncements } from './Announcements.store';

const Announcements = () => {
  const { pathname } = useLocation();
  const { open, setOpen, setType } = useAnnouncementDialog();
  const { refetch, isFetching } = useFetchAnnouncements();

  const selectedTab = ANNOUNCEMENTS_TABS.findIndex(
    (tabItem) => tabItem.path === pathname
  );

  return (
    <>
      <Header
        title="Announcements"
        actions={
          <CheckPermissions permissions={PERMISSIONS.ANNOUNCEMENT_CREATE}>
            <Button
              onClick={() => {
                setOpen(!open);
                setType(AnnouncementDialogType.CREATE);
              }}
              variant="contained"
            >
              Create Announcement
            </Button>
            <Button variant="outlined" onClick={() => refetch()}>
              <FontAwesomeIcon size="lg" icon={faRefresh} />
            </Button>
          </CheckPermissions>
        }
        actionsNewLine
      >
        <CheckPermissions permissions={PERMISSIONS.ANNOUNCEMENT_CREATE}>
          <Tabs
            allowScrollButtonsMobile
            aria-label="administration tabs"
            scrollButtons="auto"
            sx={{ pl: '1.5rem' }}
            value={selectedTab}
            variant="scrollable"
          >
            {ANNOUNCEMENTS_TABS.map((tabItem) => (
              <Tab
                aria-label={tabItem.ariaLabel}
                key={tabItem.label}
                label={tabItem.label}
                component={NavLink}
                to={tabItem.path}
              />
            ))}
          </Tabs>
        </CheckPermissions>
      </Header>
      {open && <AnnouncementDialog />}
      <MainContent>
        <LoadingIndicator isLoading={isFetching} />
        <Outlet />
      </MainContent>
    </>
  );
};

export default Announcements;
